export default function getAccountDisclaimer(account, locale) {
    return locale === "es" ? account.disclaimerES : account.disclaimer;
}



// WEBPACK FOOTER //
// ./src/assets/scripts/utils/getAccountDisclaimer.ts